import React, { useState, useRef, useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import { Button, FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from "@mui/material";

import kutil, { type PageInfo } from "@modules/kutil";
import commonCode, { type Code } from "@modules/common_code";
import valueFormatter from "@modules/value_formatter";

import { useAuthStore } from "@user/store/auth_store";

import "./popup_loadcapa_rate.scoped.scss";

interface State {
}

const defState = {
};

interface Info {
  skuNo: string,
  loadPossRate: string,
  loadRate: string
}

const defInfo = {
  skuNo: "",
  loadPossRate: "",
  loadRate: ""
};

const validationMsg = [
  {id: "skuNo", type: "NotBlank", msg: "SKU No를 확인해 주세요."},
  {id: "loadRate", type: "NotNull", msg: "적재가능률을 선택해 주세요."}
];

function PopupLoadcapaRate(props: any) {
  const auth = useAuthStore(useShallow((state) => state.getAuth(props.id)));
  const [state, setState] = useState<State>(kutil.deepCopy(defState));
  const [info, setInfo] = useState<Info>(kutil.deepCopy(defInfo));

  useEffect(() => {
    init();
  }, []);

  const isInit = useRef(false);
  async function init() {
    try {
      if (isInit.current == false) {
        isInit.current = await initData();
      }
      if (isInit.current) {
        await initParams();
        await searchInfo();
      }
    } finally {
      kutil.setLoadingStatus(false);
    }
  }

  async function initData() {
    return true;
  }

  async function initParams() {
    const skuInfo = props.data.info;
    const loadPossRate = String(100 - Number(skuInfo.stockRate ?? 0));
    setInfo(prev => ({ ...prev, skuNo: skuInfo.skuNo, loadPossRate: loadPossRate, loadRate: skuInfo.stockRate }));
  }

  async function searchInfo() {
  }

  async function closePopup() {
    props.onClose();
  }
  
    async function save() {
      const isValid = await kutil.checkValidation(info, validationMsg);
      if (isValid == false) {
        return;
      }
  
      try {
        const data = await kutil.sendPost("/api/inoutbound/workstation_manage.proc?mode=updateLoadRate", info, {
        });
        props.onClose({isSuccess: true});
      } catch(e) {
        console.log(e);
      }
    }
  
  return (
    <>
      {/* 팝업 */}
      <Dialog
        sx={{"& .MuiDialog-container": {"& .MuiPaper-root": {width: "100%", maxWidth: "600px",},},}}
        aria-labelledby="customized-dialog-title"
        open={props.isShow}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          적재가능률 입력
        </DialogTitle>
        <DialogContent>
          {/* 팝업 내용 */}
          <div className="popup-contents">
            {/* 적재가능률 선택 */}
            <FormControl>
              <RadioGroup
                row
                value={info.loadPossRate}
                onChange={(e) => {setInfo(prev => ({ ...prev, loadPossRate: e.target.value, loadRate: String(100 - Number(e.target.value)) }))}}
              >
              {(commonCode.loadRate as any[]).map((code) => (
                <FormControlLabel key={code.code} value={code.code} control={<Radio size="small" />} label={code.value} />
              ))}
              </RadioGroup>
            </FormControl>
          </div>
          {/*// 팝업 내용 */}
        </DialogContent>
        <DialogActions>
          { auth.write &&
          <Button variant="contained" autoFocus onClick={save}>
            확인
          </Button>
          }
        </DialogActions>
      </Dialog>
      {/*// 팝업 */}
    </>
  );
}

export default React.memo(PopupLoadcapaRate);
